import { useEffect } from "react";
import { videoTag } from "../constants";
import { handleClickVideoCard } from "redux-share/actions";
import { useRouter } from "next/router";
import store from "redux-share/store";

const useRouteChange = () => {
    const router = useRouter();
    useEffect(() => {
        const handleRouteChange = () => {
            if (store.getState().videoData.params.homeButtonClickFlag && videoTag()) {
                const searchParams = new URLSearchParams(window.location.search);
                const type = searchParams.get("type");
                const id = searchParams.get("id");
                handleClickVideoCard(id, type, true);
            }
        }
        router.events.on("routeChangeStart",handleRouteChange);

        return () => router.events.off("routeChangeStart", handleRouteChange);
        
    }, [])
}

export default useRouteChange;